import React from "react";
const KnowledgeBase = ({ color = "white", className, ...props }) => {
  return (
    <svg
      width="42"
      height="31"
      viewBox="0 0 42 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8559 2.45389C10.3547 2.45389 9.13672 3.67186 9.13672 5.17307V5.62626H17.5775C17.9085 5.62626 18.2148 5.44569 18.3741 5.15358L19.546 3.00267C19.6522 2.80971 19.7709 2.62736 19.9001 2.45389H11.8559ZM11.8559 0.641113C9.35272 0.641113 7.32394 2.66989 7.32394 5.17307V5.62626C4.82077 5.62626 2.79199 7.65503 2.79199 10.1582V26.02C2.79199 28.5232 4.82077 30.552 7.32394 30.552H34.5157C37.0188 30.552 39.0476 28.5232 39.0476 26.02V5.17307C39.0476 2.66989 37.0188 0.641113 34.5157 0.641113H11.8559ZM23.5257 2.45389C22.5308 2.45389 21.6137 2.99737 21.1376 3.87013L19.9656 6.02281C19.4877 6.89557 18.5724 7.43904 17.5775 7.43904H7.32399C5.82278 7.43904 4.60482 8.657 4.60482 10.1582V26.02C4.60482 27.5213 5.82278 28.7392 7.32399 28.7392H34.5157C36.0169 28.7392 37.2349 27.5213 37.2349 26.02V5.17307C37.2349 3.67186 36.0169 2.45389 34.5157 2.45389H23.5257Z"
        fill={color}
      />
    </svg>
  );
};

export default KnowledgeBase;
